<div [ngClass]="{ 'flex flex-col gap-4 frame pb-5 my-2': true, 'border-red-500': globalError | async }">
  <!-- Action Buttons -->
  <div class="flex gap-4 items-center bg-surface-50 dark:bg-surface-800 rounded-t-lg p-5" *ngIf="(disabled | async) === false">
    <p-button type="button" [label]="'dac.form.addPrix' | translate" (onClick)="addDacPrix()" [disabled]="disabled | async">
      <i class="pi pi-plus"></i>
    </p-button>

    <p-button
      type="button"
      [label]="'common.text_groups.remove_all' | translate"
      (onClick)="clearAllDacPrix()"
      severity="secondary"
      [disabled]="(disabled | async) || dacPrixList.length === 0">
      <i class="pi pi-trash"></i>
    </p-button>
  </div>

  <!-- Prix Entries -->
  <div class="flex flex-col gap-0.5">
    <div *ngFor="let item of dacPrixList; let i = index; trackBy: trackByFn">
      <div class="flex flex-row gap-5 p-5 justify-center items-center">
        <div class="flex flex-col gap-4 w-full">
          <div class="flex flex-col xl:flex-row gap-4 w-full items-start">
            <!-- Monnaie Dropdown -->
            <div class="flex flex-col gap-2 w-full xl:w-1/2">
              <label [for]="'currency-' + uid + i" class="text-xs font-bold">
                {{ 'dac.form.currency' | translate }}
              </label>
              <p-select
                [options]="currencyOptions"
                optionLabel="name"
                optionValue="code"
                dataKey="code"
                appendTo="body"
                [showClear]="true"
                [placeholder]="'dac.form.placeholders.currency' | translate"
                [ngModel]="item['monnaieId']"
                (ngModelChange)="updateMonnaie(i, $event)"
                [disabled]="!!(disabled | async)"
                [class.ng-invalid]="(errors | async)?.[i]?.monnaieId"
                [class.ng-dirty]="(errors | async)?.[i]?.monnaieId"
                class="w-full">
              </p-select>
              <p class="text-xs text-red-500 font-bold" *ngIf="(errors | async)?.[i]?.monnaieId || ''">
                {{ (errors | async)?.[i]?.monnaieId }}
              </p>
            </div>

            <!-- Prix Input -->
            <div class="flex flex-col gap-2 w-full xl:w-1/2">
              <label [for]="'prix-' + uid + i" class="text-xs font-bold">
                {{ 'dac.form.price' | translate }}
              </label>
              <p-inputnumber
                mode="decimal"
                fluid
                minFractionDigits="0"
                maxFractionDigits="2"
                [ngModel]="item.prix"
                (ngModelChange)="updatePrix(i, $event)"
                [disabled]="!!(disabled | async)"
                [class.ng-invalid]="(errors | async)?.[i]?.prix"
                [class.ng-dirty]="(errors | async)?.[i]?.prix"
                class="w-full">
              </p-inputnumber>
              <p class="text-xs text-red-500 font-bold" *ngIf="(errors | async)?.[i]?.prix || ''">
                {{ (errors | async)?.[i]?.prix }}
              </p>
            </div>
          </div>
        </div>

        <!-- Remove Button -->
        <div class="mt-5">
          <button type="button" (click)="removeDacPrix(i)" [disabled]="disabled | async">
            <i [ngClass]="['pi pi-eraser', disabled ? 'text-gray-200' : 'hover:text-red-500']"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
